import {isFSA} from 'flux-standard-action'
import {
    agentActions,
    userRole
} from '../actions'
import * as types from '../constants/ActionTypes'
import EventBus from '../components/eventBus';


let middleware = ({dispatch, getState}) => {
    return next => action => {
        if(action.type === types.GET_AGENT_FINISH){
            if(!action.error&&action.payload.agent.userType===10){
                dispatch(userRole.searchRoles())
                EventBus.emit('login', '/setCenter');
            }

        }
        return next(action)
    }
}

export default middleware
